module.exports = __webpack_public_path__ + "header-logo-8deeb0ea2314b6266c2313b18ed6bac9.png";